import { render } from "./HerbalAdvice.vue?vue&type=template&id=21d52b6d"
import script from "./HerbalAdvice.vue?vue&type=script&lang=js"
export * from "./HerbalAdvice.vue?vue&type=script&lang=js"

import "./HerbalAdvice.vue?vue&type=style&index=0&id=21d52b6d&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__